import 'src/pages/userComponents/userStyle.scss';
import 'antd/dist/antd.css';

import { Col, Dropdown, Form, Menu } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';

import AppLoader from '@sharedComponent/app-loader';
import CdtPage from './cdtpage';
import DeliveryAdditionalContacts from './deliverycardAdditionalContacts';
import DropdownArrow from 'src/assets/img/SalesForce_Icon/DropdownArrow.svg';
import InputCustom from '../../../text-field/index';
import MapFunctional from '@sharedComponent/g-map/MapFunctional';
import MapFunctionalTest from '@sharedComponent/emirate-search/MapEmirateSearchFunc';
import SalesForceCheckBox from './salesForceCheckbox';
import SalesForceCheckBox1 from './salesForceCheckbox';
import StepButton from '@pages/userComponents/Step-Button/StepButton';
import TextComponent from '@sharedComponent/typography/TextComponent';
import { useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

// import DropDownInput from '../../../Drop-down-field/index';
// import '../userStyle.scss';

const DeliveryCardPresentational = (
	{ navigateDisabled, companyInfoDetails, handleSubmit, deliveryInfoData, isdeliveryLoading, deliverySavingData, additionalContacts },
	props
) => {
	const history = useHistory();
	const [area, setArea] = useState('');
	const [phoneNumber, setPhoneNumber] = useState('');
	const [buildName, setBuildingName] = useState('');
	const [landmark, setLandmark] = useState('');
	const [areasArray, setAreaArray] = useState([
		'England Cluster- International city',
		'Emirates Hills',
		'Business Bay',
		'Mussafah Community',
		'Al Quoz Industial Area 2',
		'Mirdif',
		'Industrial Area 3',
		'Deira',
		'Industrial Area',
		'Al Muraqqabay',
		'Al Sufouh',
	]);
	const [allow, setAllow] = useState(false);
	const [companyInfo, setCompanyInfo] = useState(companyInfoDetails?.());
	const [selectedEmirates, setSelectedEmirates] = useState(null);
	const [mainPayrollCheckBox, setMainPayrollCheckBox] = useState(false);
	const [someoneCheckBox, setSomeoneCheckBox] = useState(false);
	const [emirates, setEmirates] = useState(['Dubai', 'Sharjah', 'Abu Dhabi', 'RAK', 'Fujairah', 'UAQ', 'Ajman']);
	const [lat, setLat] = useState(null);
	const [lng, setLng] = useState(null);
	const [selectedLng, setSelectedLng] = useState(null);
	const [selectedLat, setSelectedLat] = useState(null);
	const [additionalDeliverycards, setAdditionalDeliverycards] = useState(
		deliveryInfoData && deliveryInfoData.contactList && deliveryInfoData.contactList.length > 0 ? deliveryInfoData.contactList : []
	);
	const [errorMsgList, setErrorMsgList] = useState({
		locationerr: '',
		emirateerr: '',
		areaerr: '',
		nearestLandmarkerr: '',
		offNumbererr: '',
		BuildingNameerr: '',
	});
	const handleMenuClick = (e) => {
		// console.log('clicked', e);
		setArea(e.key);
	};
	useEffect(() => {
		if (deliveryInfoData && deliveryInfoData) {
			let latLngFromApi =
				deliveryInfoData.coordinate && deliveryInfoData.coordinate && deliveryInfoData.coordinate !== 'null, null'
					? deliveryInfoData.coordinate.split(',')
					: setCurrentLocationToMap();
			let latFromApi = latLngFromApi && latLngFromApi.length > 0 ? latLngFromApi[0] : '';
			let lngFromApi = latLngFromApi && latLngFromApi.length > 0 ? latLngFromApi[1] : '';

			setLat(parseFloat(latFromApi) || '');
			setLng(parseFloat(lngFromApi) || '');

			// if (lat !== latFromApi && lng !== lngFromApi) {
			// 	setSelectedLat(latFromApi || '');
			// 	setSelectedLng(lngFromApi || '');
			// }

			setPhoneNumber(deliveryInfoData.officeNumber || '');
			setBuildingName(deliveryInfoData.buildingName || '');
			setLandmark(deliveryInfoData.landmark || '');
			setArea(deliveryInfoData.area || '');
			setSelectedEmirates(deliveryInfoData.emirateName || '');
			setMainPayrollCheckBox(deliveryInfoData.mainPayrollContact || false);
			const newTempArr =
				deliveryInfoData.contactList &&
				deliveryInfoData.contactList.length > 0 &&
				deliveryInfoData.contactList.map((cInfo, i) => {
					return {
						index: uuidv4(),
						hrName: cInfo?.name || null,
						hrMobile: cInfo?.mobile || null,
						hrLandline: cInfo?.landLine || null,
						hrEmail: cInfo?.email || null,
						contactType: cInfo?.contactType || 'Delivery',
						contactId: cInfo?.contactId || null,
					};
				});
			setAdditionalDeliverycards(newTempArr || []);
		} else {
			setCurrentLocationToMap();
		}
	}, [deliveryInfoData]);

	/** For feature reference */
	// useEffect(() => {
	// 	setCurrentLocationToMap();
	// }, []);

	const setCurrentLocationToMap = () => {
		const location = window.navigator && window.navigator.geolocation;

		if (location) {
			location.getCurrentPosition(
				(position) => {
					setLat(position.coords.latitude);
					setLng(position.coords.longitude);
					setSelectedLat(position.coords.latitude);
					setSelectedLng(position.coords.longitude);
				},
				(error) => {
					console.log(error);
					// this.setState({ lat: 'err-latitude', lng: 'err-longitude' });
					setLat(25.1988);
					setLng(55.2796);
				}
			);
		}
	};

	const setValuesForAddressForm = (value) => {
		setSelectedEmirates(value.area);
		if (areasArray.includes(value.area)) {
			setArea(value.area);
		}
		if (value.phoneNumber) {
			setPhoneNumber(value.phoneNumber);
		}

		if (value.name) {
			setBuildingName(value.name);
		}
	};
	const setValuesForArea = (value) => {
		if (areasArray.includes(value.area)) {
			setArea(value.area);
		}
	};

	const addDeliveryCard = (value1) => {
		setSomeoneCheckBox(!someoneCheckBox);
		if (!someoneCheckBox) {
			!additionalDeliverycards?.length && handleAddDeliveryCards();
		}
		if (mainPayrollCheckBox) {
			setMainPayrollCheckBox(false);
		}

		if (!someoneCheckBox && count == 0) {
			setCount(1);
		} else {
			setCount(0);
		}
	};
	const mainPayrollContactOnClick = (value1, value2) => {
		if (someoneCheckBox) {
			setSomeoneCheckBox(false);
			setAdditionalDeliverycards([]);
		}
		setMainPayrollCheckBox(!mainPayrollCheckBox);

		if (someoneCheckBox && count == 0) {
			setCount(1);
		} else {
			setCount(0);
		}
	};

	const menu = (
		<Menu onClick={handleMenuClick}>
			{/* {areasArray.map((res, index) => { */}
			{areasArray.map((res) => (
				<Menu.Item key={res}>{res}</Menu.Item>
			))}
		</Menu>
	);

	const onFinish = (values) => {
		if (area !== '' && landmark !== '' && selectedEmirates !== '' && allow) {
			navigateDisabled?.(false);
		} else {
			navigateDisabled?.(true);
		}
	};

	const [count, setCount] = useState(0);

	const removeAdditionalDocuments = (index) => {
		let additionalDocumentsTemp = additionalDeliverycards.filter((data) => data.index !== index);
		setAdditionalDeliverycards([...additionalDocumentsTemp]);
	};
	const validateMessages = (changeValue, allValue) => {
		let name = Object.keys(changeValue);
		name = name[0];
		if (name === 'NearestLandmark') {
			setLandmark(changeValue.NearestLandmark);
		}
		if (allValue.officeNumber && allValue.officeNumber.replace(/[^0-9]/g, '').length !== 8) {
			setAllow(false);
		} else {
			setAllow(true);
		}
	};

	const handleAddDeliveryCards = () => {
		const index = uuidv4();
		setAdditionalDeliverycards([
			...additionalDeliverycards,
			{ index, hrName: ``, hrMobile: '', hrLandline: '', hrEmail: '', contactType: 'Delivery', contactId: null },
		]);
	};
	// console.log('ADDITIONAL DATA ::', additionalDeliverycards);

	const handleValueChange = (index, key, value) => {
		let additionalDeliverycardsTemp = additionalDeliverycards.map((data) => {
			if (data.index === index) {
				return {
					...data,
					[key]: value,
				};
			} else return data;
		});
		setAdditionalDeliverycards([...additionalDeliverycardsTemp]);
	};

	const isAdditionalContactsValid = useMemo(
		() =>
			additionalDeliverycards?.filter(
				(data) =>
					/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
						data?.hrEmail?.toLowerCase()
					) &&
					data?.hrMobile.length === 8 &&
					data?.hrName
			).length === additionalDeliverycards.length,
		[additionalDeliverycards]
	);

	const onAreaSelected = (place) => {
		try {
			//For Future Reference
			// console.log('PLACE ::', place);
		} catch (error) {
			console.log(error);
		}
	};

	const getLatLngFromSelected = (lat, lng) => {
		setSelectedLat(lat);
		setSelectedLng(lng);
	};
	return (
		<Col>
			{isdeliveryLoading ? (
				<AppLoader />
			) : (
				<>
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<TextComponent className="heading_3_text">Where Should We Deliver Your Cards?</TextComponent>
						<TextComponent className="text2" style={{ marginTop: '10px' }}>
							<p>Please mark your exact location as the cards will be delivered here..</p>
						</TextComponent>
						{/* <TextComponent className="text"></TextComponent> */}
					</div>

					<div style={{ position: 'relative', minHeight: 300 }} className="g-maps">
						{lat && lng ? (
							<MapFunctional
								google={props.google}
								center={{ lat: lat, lng: lng }}
								height="300px"
								zoom={15}
								setValuesForAddressForm={setValuesForAddressForm}
								getLatLngFromSelected={getLatLngFromSelected}
							/>
						) : null}
					</div>

					<div className="emirates_contact_wrapper">
						<TextComponent className="heading_4_text">
							Emirate <text style={{ color: 'red' }}>*</text>
						</TextComponent>
						<div className="emirates_place_container">
							{emirates.map((res) => (
								<button
									name="Emirates"
									onClick={() => setSelectedEmirates(res)}
									className={selectedEmirates == res ? 'emitratebtn_selected' : 'emitratebtn'}>
									{res}
								</button>
							))}
						</div>
						<div>
							<TextComponent className="errorText">{errorMsgList.emirateerr}</TextComponent>
						</div>
					</div>
					<div className="delivery__form_container">
						<Form onFinish={onFinish} onValuesChange={validateMessages}>
							<Form.Item name="Area" value={area} initialValue={area}>
								{/* <DeliveryCardAutoSearchMap /> */}
								<div style={{ height: '9vh' }}>
									<MapFunctionalTest
										google={props.google}
										center={{ lat: lat, lng: lng }}
										height="300px"
										zoom={15}
										setArea={setArea}
										setValuesForArea={setValuesForArea}
										deliveryInfoData={deliveryInfoData}
									/>
								</div>
							</Form.Item>
							<Form.Item
								name="NearestLandmark"
								initialValue={landmark}
								rules={[{ required: true, message: 'Landmark field should not  be empty' }]}>
								<div className="global_input_Container">
									<InputCustom
										name="NearestLandmark"
										type="text"
										labels={
											<span>
												Nearest Landmark <text style={{ color: 'red' }}>*</text>
											</span>
										}
										value={landmark}
									/>
									<div>
										<TextComponent className="errorText">{errorMsgList.nearestLandmarkerr}</TextComponent>
									</div>
								</div>
							</Form.Item>
							<Form.Item name="officeNumber" initialValue={phoneNumber}>
								<div className="global_input_Container">
									<InputCustom
										type="text"
										labels={<span>Office Number</span>}
										name="officeNumber"
										maxLength={8}
										value={phoneNumber}
										onChange={(e) => setPhoneNumber(e.target.value.replace(/[^0-9]/g, ''))}
									/>
									<div>
										<TextComponent className="errorText">{errorMsgList.offNumbererr}</TextComponent>
									</div>
								</div>
							</Form.Item>
							<Form.Item name="buildingName" initialValue={buildName}>
								{/* <InputCustom type="text" labels="Building Name" value={buildName} /> */}
								<div className="global_input_Container">
									<InputCustom
										type="text"
										labels={<span>Building Name</span>}
										value={buildName}
										name="buildingName"
										onChange={(e) => setBuildingName(e.target.value)}
									/>
									<div>
										<TextComponent className="errorText">{errorMsgList.BuildingNameerr}</TextComponent>
									</div>
								</div>
							</Form.Item>
						</Form>
					</div>
					{/* companyInfo && companyInfo.payrollCardNumber */}
					{companyInfo && companyInfo.payrollCardNumber > 100 ? (
						<CdtPage navigateDisabled={navigateDisabled}></CdtPage>
					) : (
						<div>
							<div className="Main_Hr_headercontainer">
								<TextComponent className="heading_3_text">Who Should We Deliver The Card to?</TextComponent>

								<div style={{ padding: '25px 0px' }}>
									<SalesForceCheckBox
										onCheck={mainPayrollContactOnClick}
										isChecked={mainPayrollCheckBox}
										text={'The main payroll contact'}></SalesForceCheckBox>
								</div>
								<div>
									<SalesForceCheckBox1
										onCheck={addDeliveryCard}
										isChecked={someoneCheckBox}
										text={'Someone else'}></SalesForceCheckBox1>
								</div>
							</div>
							{/* {[...Array(count)].map((_, i) => (
								<DeliveryAdditionalContacts navigateDisabled={navigateDisabled} key={i} removeContact={removeContact} />
							))} */}
							{someoneCheckBox && (
								<>
									{additionalDeliverycards &&
										additionalDeliverycards.map(({ index, hrName, hrMobile, hrLandline, hrEmail }, i) => (
											<DeliveryAdditionalContacts
												navigateDisabled={navigateDisabled}
												key={i}
												length={additionalDeliverycards.length}
												removeContact={removeAdditionalDocuments}
												{...{ index, hrName, hrMobile, hrLandline, hrEmail, handleValueChange }}
											/>
										))}
									<div className="addbtn">
										<button
											className="btn-add-contact"
											onClick={() => {
												// setCount(count + 1);
												handleAddDeliveryCards();
											}}>
											<span style={{ marginRight: '10px', fontSize: '20px', fontWeight: '300' }}>+</span> Add Additional
											Contacts
										</button>
									</div>
								</>
							)}
						</div>
					)}
				</>
			)}
			<StepButton
				loading={deliverySavingData}
				{...{
					...someoneCheckBox,
				}}
				disabled={(someoneCheckBox ? !isAdditionalContactsValid : false) || landmark === '' || area === ''}
				handleNext={() => {
					handleSubmit(
						{
							emirateName: selectedEmirates,
							area: area,
							landmark: landmark,
							officeNumber: phoneNumber,
							buildingName: buildName,
							mainPayrollContact: true,
							contactList: additionalDeliverycards,
							coordinate: `${selectedLat}, ${selectedLng}`,
						},
						mainPayrollCheckBox
					);
				}}
				buttonText={'Next'}
			/>
		</Col>
	);
};
export default DeliveryCardPresentational;
